/*
 * @Author: Roman
 * @Date: 2023-02-22 14:50:54
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-05-11 18:02:55
 * @FilePath: \qpmn-site\src\app\modules\user\rest\account\rest\users-rest.service.config.ts
 * @Description: 
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { appConfig } from "@env/app-config";
import { envConfig } from "@env/env-config";
let UsersRestServiceConfig: IRestfulConfigMap = {
    "usersRestService": {
        // TODO base对应接口地址
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取用户信息
            // getUserInfo
            get: {
                method: "get",
                path: "api/userInfo",
                testPath: "api/userInfo"
            },
            // 保存用户信息
            // saveUserInfo
            save: {
                method: "put",
                path: "api/userInfo",
                testPath: "api/userInfo"
            },
            // 修改用户信息v2接口
            modifyV2: {
                method: "put",
                path: "api/v2/userInfo",
                testPath: "api/v2/userInfo"
            },
            // 修改密码
            // changePassword
            changePassword: {
                method: "put",
                path: "api/userInfo/password",
                testPath: "api/userInfo/password"
            },
            // 修改邮箱
            // modifyEmail
            modifyEmail: {
                method: "put",
                path: "api/v2/userInfo/email",
                testPath: "api/v2/userInfo/email",
            },
            // 邮箱验证
            // mailValidation
            mailValidation: {
                method: "get",
                path: "userInfo/email/validation",
                testPath: "userInfo/email/validation",
                paramDefaults: { token: "@token" },
                isAuth: false
            }
        }
    }
}

export { UsersRestServiceConfig };

